export const RESET_RATE_CALCULATOR_DATA = 'RESET_RATE_CALCULATOR_DATA';
export const UPDATE_BASE_RATE_MILES = 'UPDATE_BASE_RATE_MILES';
export const UPDATE_BASE_RATE_PER_MILE = 'UPDATE_BASE_RATE_PER_MILE';
export const UPDATE_BASE_RATE_ROW_TOTAL = 'UPDATE_BASE_RATE_ROW_TOTAL';
export const UPDATE_FUEL_SURCHARGE_MILES = 'UPDATE_FUEL_SURCHARGE_MILES';
export const UPDATE_FUEL_SURCHARGE_RATE_PER_MILE = 'UPDATE_FUEL_SURCHARGE_PER_MILE';
export const UPDATE_FUEL_SURCHARGE_ROW_TOTAL = 'UPDATE_FUEL_SURCHARGE_ROW_TOTAL';
export const UPDATE_EMPTY_MILES = 'UPDATE_EMPTY_MILES';
export const UPDATE_EMPTY_MILES_RATE_PER_MILE = 'UPDATE_EMPTY_MILES_RATE_PER_MILE';
export const UPDATE_NUMBER_OF_STOPS = 'UPDATE_NUMBER_OF_STOPS';
export const UPDATE_NUMBER_OF_STOPS_COST_PER_STOP = 'UPDATE_NUMBER_OF_STOPS_COST_PER_STOP';
export const UPDATE_LOADING_FEE = 'UPDATE_LOADING_FEE';
export const UPDATE_UNLOADING_FEE = 'UPDATE_UNLOADING_FEE';
export const UPDATE_MARKUP_PERCENTAGE = 'UPDATE_MARKUP_PERCENTAGE';
export const UPDATE_FLAT_FEE = 'UPDATE_FLAT_FEE';
export const UPDATE_ADD_ON_TOTAL = 'UPDATE_ADD_ON_TOTAL';
export const UPDATE_NOTES = 'UPDATE_NOTES';
export const UPDATE_GRAND_TOTAL = 'UPDATE_GRAND_TOTAL';
export const UPDATE_ALL_IN_RATE_PER_MILE = 'UPDATE_ALL_IN_RATE_PER_MILE';

export const resetRateCalculatorData = (): object => {
    return {
        type: RESET_RATE_CALCULATOR_DATA
    };
};

export const setBaseRateMiles = (miles: string): object => {
    return {
        type: UPDATE_BASE_RATE_MILES,
        payload: miles
    };
};

export const setBaseRatePerMile = (rate: string): object => {
    return {
        type: UPDATE_BASE_RATE_PER_MILE,
        payload: rate
    };
};

export const setBaseRateRowTotal = (total: string): object => {
    return {
        type: UPDATE_BASE_RATE_ROW_TOTAL,
        payload: total
    };
};

export const setFuelSurchargeMiles = (miles: string): object => {
    return {
        type: UPDATE_FUEL_SURCHARGE_MILES,
        payload: miles
    };
};

export const setFuelSurchargePerMile = (rate: string): object => {
    return {
        type: UPDATE_FUEL_SURCHARGE_RATE_PER_MILE,
        payload: rate
    };
};

export const setFuelSurchargeRowTotal = (total: string): object => {
    return {
        type: UPDATE_FUEL_SURCHARGE_ROW_TOTAL,
        payload: total
    };
};

export const setEmptyMiles = (miles: string): object => {
    return {
        type: UPDATE_EMPTY_MILES,
        payload: miles
    };
};

export const setEmptyMilesRatePerMile = (rate: string): object => {
    return {
        type: UPDATE_EMPTY_MILES_RATE_PER_MILE,
        payload: rate
    };
};

export const setNumberOfStops = (stops: string): object => {
    return {
        type: UPDATE_NUMBER_OF_STOPS,
        payload: stops
    };
};

export const setNumberOfStopsCostPerStop = (rate: string): object => {
    return {
        type: UPDATE_NUMBER_OF_STOPS_COST_PER_STOP,
        payload: rate
    };
};

export const setLoadingFee = (rate: string): object => {
    return {
        type: UPDATE_LOADING_FEE,
        payload: rate
    };
};

export const setUnloadingFee = (rate: string): object => {
    return {
        type: UPDATE_UNLOADING_FEE,
        payload: rate
    };
};

export const setMarkupPercentage = (percentage: string): object => {
    return {
        type: UPDATE_MARKUP_PERCENTAGE,
        payload: percentage
    };
};

export const setFlatFee = (rate: string): object => {
    return {
        type: UPDATE_FLAT_FEE,
        payload: rate
    };
};

export const setAddOnTotal = (total: string): object => {
    return {
        type: UPDATE_ADD_ON_TOTAL,
        payload: total
    };
};

export const setNotes = (notes: string): object => {
    return {
        type: UPDATE_NOTES,
        payload: notes
    };
};

export const setGrandTotal = (total: string): object => {
    return {
        type: UPDATE_GRAND_TOTAL,
        payload: total
    };
};

export const setAllInRatePerMile = (ratePerMile: string): object => {
    return {
        type: UPDATE_ALL_IN_RATE_PER_MILE,
        payload: ratePerMile
    };
};
